import * as actionType from './ActionType';

const initialState = {
  iframeOptions: null
};

export function globalpayReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.SET_GLOBALPAY_IFRAME_RESPONSE:
      return {
        ...state,
        iframeOptions: action.payload
      };
    default:
      return state;
  }
}
